import { ToggleLeft, ToggleRight } from "@phosphor-icons/react";

export default function AdminToggle({ enabled, onToggle, size = 40, disabled = false, ...props }) {
  return (
    <button
      type="button"
      onClick={onToggle}
      disabled={disabled}
      className={`transition-colors disabled:opacity-40 disabled:cursor-not-allowed ${enabled ? "text-indigo-600" : "text-slate-300"}`}
      {...props}
    >
      {enabled
        ? <ToggleRight size={size} weight="fill" />
        : <ToggleLeft size={size} />}
    </button>
  );
}
